import { CIActionEnum, SetChartDataAction, SetIndexIdAction } from "./types";

export const CIActionCreators = {
  
  setIndexId: (payload: any): SetIndexIdAction => ({
    type: CIActionEnum.SET_INDEX_ID,
    payload,
  }),

  setChartData: (payload: any): SetChartDataAction => ({
    type: CIActionEnum.SET_CHART_DATA_TYPE,
    payload,
  }),
};
